import type { SubdivisionCatalog } from "./types";

/** Colombia — 32 departments plus the capital district, which ISO lists as a subdivision of its own. */
export const COL_SUBDIVISIONS: SubdivisionCatalog = [
  { code: "CO-AMA", name: "Amazonas" },
  { code: "CO-ANT", name: "Antioquia" },
  { code: "CO-ARA", name: "Arauca" },
  { code: "CO-ATL", name: "Atlántico" },
  { code: "CO-BOL", name: "Bolívar" },
  { code: "CO-BOY", name: "Boyacá" },
  { code: "CO-CAL", name: "Caldas" },
  { code: "CO-CAQ", name: "Caquetá" },
  { code: "CO-CAS", name: "Casanare" },
  { code: "CO-CAU", name: "Cauca" },
  { code: "CO-CES", name: "Cesar" },
  { code: "CO-CHO", name: "Chocó" },
  { code: "CO-COR", name: "Córdoba" },
  { code: "CO-CUN", name: "Cundinamarca" },
  { code: "CO-DC", name: "Distrito Capital de Bogotá", aliases: ["Bogotá", "Bogota", "D.C."] },
  { code: "CO-GUA", name: "Guainía" },
  { code: "CO-GUV", name: "Guaviare" },
  { code: "CO-HUI", name: "Huila" },
  { code: "CO-LAG", name: "La Guajira" },
  { code: "CO-MAG", name: "Magdalena" },
  { code: "CO-MET", name: "Meta" },
  { code: "CO-NAR", name: "Nariño" },
  { code: "CO-NSA", name: "Norte de Santander" },
  { code: "CO-PUT", name: "Putumayo" },
  { code: "CO-QUI", name: "Quindío" },
  { code: "CO-RIS", name: "Risaralda" },
  // Constitutional name — "Archipiélago de San Andrés, Providencia y Santa Catalina" — is 56 chars and does
  // not fit the address field. The ISO list name drops the "Archipiélago de" and fits at 40.
  {
    code: "CO-SAP",
    name: "San Andrés, Providencia y Santa Catalina",
    aliases: ["San Andrés", "Providencia", "Archipiélago"],
  },
  { code: "CO-SAN", name: "Santander" },
  { code: "CO-SUC", name: "Sucre" },
  { code: "CO-TOL", name: "Tolima" },
  { code: "CO-VAC", name: "Valle del Cauca", aliases: ["Valle"] },
  { code: "CO-VAU", name: "Vaupés" },
  { code: "CO-VID", name: "Vichada" },
];
